import React, { useEffect, useState } from 'react';
import { getAppInsights } from '../AppInsights';
import '../App.css';
import logo from '../img/logo.png';

type Platform = 'ios' | 'android' | 'desktop';

const Get = () => {
  const [platform, setPlatform] = useState<Platform | null>(null);
  const appInsights = getAppInsights();
  const appStoreUrl = 'https://apps.apple.com/us/app/beta-builder/id6740149361';

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    let detectedPlatform: Platform = 'desktop';

    // Detect iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      detectedPlatform = 'ios';
    }
    // Detect Android
    else if (/android/i.test(userAgent)) {
      detectedPlatform = 'android';
    }

    setPlatform(detectedPlatform);

    // Check if came from QR code scan
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source') || 'direct';
    const campaign = urlParams.get('campaign') || 'none';

    // Track the platform visit with platform metadata
    appInsights?.trackEvent({
      name: 'GetPageVisit',
      properties: {
        platform: detectedPlatform,
        userAgent: userAgent,
        source: source,
        campaign: campaign
      }
    });

    // Auto-redirect iOS users to App Store
    if (detectedPlatform === 'ios') {
      window.location.href = appStoreUrl;
    }
  }, [appInsights, appStoreUrl]);

  if (platform === 'ios') {
    return (
      <div style={{ textAlign: 'center', padding: '2em' }}>
        <img src={logo} alt='Beta Builder Logo' width={150} height={150} />
        <h2>Redirecting to App Store...</h2>
        <p>If you're not redirected automatically, <a href={appStoreUrl}>click here</a>.</p>
      </div>
    );
  }

  if (platform === 'android') {
    return (
      <div style={{ textAlign: 'center', padding: '2em' }}>
        <img src={logo} alt='Beta Builder Logo' width={150} height={150} />
        <h2>Android App Coming Soon</h2>
        <p><b>Sorry, there's no Android app yet.</b></p>
        <p>Beta Builder is currently available only on iOS. We're working hard to bring it to Android.</p>
        <p>Check back soon or visit <a href="/">beta-builder.com</a> for updates.</p>
      </div>
    );
  }

  // Desktop - show marketing page
  return (
    <div style={{ textAlign: 'center', padding: '2em' }}>
      <img src={logo} alt='Beta Builder Logo' width={200} height={200} />
      <h2>Get Beta Builder</h2>
      <p><b>Track your climbing progress. Send your projects.</b></p>
      <p>Beta Builder is currently available on iOS. Scan the QR code with your iPhone to download.</p>
      <div style={{ marginTop: '2em' }}>
        <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
          <button style={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold',
            backgroundColor: '#2a2a2a',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}>
            View on App Store
          </button>
        </a>
      </div>
      <p style={{ marginTop: '2em' }}>
        <a href="/">Learn more about Beta Builder</a>
      </p>
    </div>
  );
};

export default Get;
